import es from '@vueform/vueform/locales/es';
import { defineConfig } from '@vueform/vueform';
import theme from '@vueform/vueform/dist/tailwind';
import { AnonymousCredential, BlobServiceClient } from '@azure/storage-blob';

const MAX_SINGLE_SHOT_SIZE = 4 * 1024 * 1024; // 4MB

const blobContainerClient = (containerName = process.env.APP_STORAGE_CONTAINER_STARTUPS) => {
  const anonymousCredential = new AnonymousCredential();
  const blobServiceClient = new BlobServiceClient(
    `${process.env.APP_STORAGE_URI}${process.env.APP_STORAGE_SAS}`,
    anonymousCredential
  );
  return blobServiceClient.getContainerClient(containerName);
};

const uidBlobName = blobName => `${new Date().getTime()}${blobName}`;

const uploadBlob = async (blob, blobName, contentType, onProgress, containerName) => {
  const blobClient = blobContainerClient(containerName).getBlobClient(blobName);
  const blockBlobClient = blobClient.getBlockBlobClient();
  const uploadBlobResponse = await blockBlobClient.upload(blob, blob.size, {
    blobHTTPHeaders: { blobContentType: contentType },
    maxSingleShotSize: MAX_SINGLE_SHOT_SIZE,
    onProgress
  });
  return uploadBlobResponse;
};

const deleteBlob = async (blobName, containerName) =>
  await blobContainerClient(containerName).deleteBlob(blobName);

export default defineConfig({
  theme,
  locales: { es },
  locale: process.env.APP_LOCALE || 'es',
  endpoints: {
    uploadTempFile: (file, el$) =>
      new Promise(resolve => {
        const uidName = uidBlobName(file.name);
        const progressCallback = e => {
          const percentage = Math.round((e.loadedBytes / file.size) * 100);
          el$.progress = percentage;
          if (percentage === 100) {
            const response = {
              tmp: uidName,
              url: `${process.env.APP_STORAGE_URI}${process.env.APP_STORAGE_CONTAINER_STARTUPS}/${uidName}`,
              originalName: file.name
            };
            resolve(response);
          }
        };
        uploadBlob(file, uidName, file.type, progressCallback);
      }),
    removeTempFile: ({ tmp }) => {
      deleteBlob(tmp);
    },
    removeFile: ({ tmp }) => {
      deleteBlob(tmp);
    }
  }
});
